import React from 'react';
import Blade from '../Blade/Blade';
import StoreInformation from '../StoreInformation/StoreInformation';
 
const LocationBlade = () => (
  <Blade id="store-location-blade">
    <StoreInformation />
  </Blade>
);

export default LocationBlade;
